export const PICTURE_QUIZ_CATEGORY = "Picture Quiz";

export const DEFAULT_PICTURE_QUIZ_PROMPT = "What is the picture?";

export interface PictureQuizItem {
  name: string;
  svg?: string;
  svgs?: string[];
  answer?: string;
}

export interface PictureQuizSlide {
  name: string;
  svg?: string;
  svgs?: string[];
  answer?: string;
  isAnswer: boolean;
}

const shuffleItems = <T,>(array: T[]): T[] =>
  [...array].sort(() => Math.random() - 0.5);

export const expandPictureQuizToSlides = (
  items: PictureQuizItem[],
  shuffle: boolean,
): PictureQuizSlide[] => {
  const ordered = shuffle ? shuffleItems(items) : items;

  return ordered.flatMap((item) => {
    const prompt = item.name?.trim() || DEFAULT_PICTURE_QUIZ_PROMPT;
    const answer = item.answer?.trim() || "";

    return [
      {
        name: prompt,
        svg: item.svg,
        svgs: item.svgs,
        answer,
        isAnswer: false,
      },
      {
        name: answer,
        svg: item.svg,
        svgs: item.svgs,
        answer,
        isAnswer: true,
      },
    ];
  });
};

export const isPictureQuizItem = (item: {
  svg?: string;
  answer?: string;
}): boolean => Boolean(item.svg && item.answer?.trim());
